// project imports
import Locales from "shared/ui/Locales";
import StepTours from "shared/ui/tour/StepTours";
import NavigationScroll from "layout/NavigationScroll";
import RTLLayout from "shared/ui/RTLLayout";
import Snackbar from "shared/ui/extended/Snackbar";
import Notistack from "shared/ui/third-party/Notistack";
import VersionUpdateAlert from "shared/ui/VersionUpdateAlert";
import SystemNotificationAlert from "shared/ui/SystemNotificationAlert";
import ThemeCustomization from "themes";
import Router from "./Router";

const App = () => (
  <ThemeCustomization>
    <RTLLayout>
      <Locales>
        <StepTours>
          <VersionUpdateAlert />
          <SystemNotificationAlert code='UPCOMING_NOTIFICATION' />
          <NavigationScroll>
            <Notistack>
              <Router />
              <Snackbar />
            </Notistack>
          </NavigationScroll>
        </StepTours>
      </Locales>
    </RTLLayout>
  </ThemeCustomization>
);

export default App;
